export const RESET_DETAILS = 'RESET_DETAILS';
export const TOGGLE_VALIDATION_MESSAGE = 'TOGGLE_VALIDATION_MESSAGE';
export const ADD_VALIDATION_MESSAGE_TOAST = 'ADD_VALIDATION_MESSAGE_TOAST';

export default {
  RESET_DETAILS,
  TOGGLE_VALIDATION_MESSAGE,
  ADD_VALIDATION_MESSAGE_TOAST
};
